import React from 'react'
import styles from '@/styles/shared/Background.module.css'
import BlurImage from './BlurImage'

// `background` is { imageUrl, lqip } from getBackgroundFromPage
const Background = ({ background }) => {
  if (!background?.imageUrl) return <div className={`${styles.background}`}></div>;

  return (
    <div className={`${styles.background}`}>
      {/* Keyed by URL so moving to a page with a different photo starts again from its blur */}
      <BlurImage
        key={background.imageUrl}
        src={background.imageUrl}
        lqip={background.lqip}
        position="bottom"
        preload
      />
    </div>
  )
}

export default Background
